type MicroformStyles = Record<string, Record<string, string>>;

// These styles are injected into the CyberSource Flex Microform iframes, which are
// isolated from the app stylesheets — CSS custom properties / light-dark() tokens
// do not apply inside them, so theme colors must be passed as literal color
// values (hex / rgba). Values mirror _palette.scss (text.body, light and dark
// sets); disabled mirrors Angular Material's M2 disabled token (on-surface @ 38%).

const microformStylesLight: MicroformStyles = {
  input: {
    'font-size': '1.0625rem',
    color: '#000000', // text.body 900
    'font-weight': '100',
    'font-family': 'Open Sans, sans-serif',
  },
  '::placeholder': {
    color: '#8C8E90', // text.disabled 500
    'font-weight': '300',
    'font-family': 'Open Sans, sans-serif',
    'font-size': '1.0625rem',
  },
  ':focus': { color: '#000000' },
  ':disabled': { color: 'rgba(0, 0, 0, 0.38)', 'font-weight': '100' },
};

const microformStylesDark: MicroformStyles = {
  input: {
    'font-size': '1.0625rem',
    color: '#f0f0f2', // text.body dark-900
    'font-weight': '100',
    'font-family': 'Open Sans, sans-serif',
  },
  '::placeholder': {
    color: '#888892', // text.body dark-700
    'font-weight': '300',
    'font-family': 'Open Sans, sans-serif',
    'font-size': '1.0625rem',
  },
  ':focus': { color: '#f0f0f2' },
  ':disabled': { color: 'rgba(255, 255, 255, 0.38)', 'font-weight': '100' },
};

export const getMicroformStyles = (isDark: boolean): MicroformStyles =>
  isDark ? microformStylesDark : microformStylesLight;
